export default "__VITE_ASSET__DZfHvnQl__"